// Short competition names for the Stats tile's competition dropdown (the closed button; the
// open list shows the full names). The database only has full names ("UEFA Women's Champions
// League"), which would push the tile's top row too wide — so the short forms live here.
//
// Keyed on the database's full name, any case. A competition not listed keeps its full name;
// the button's CSS cuts it off with "…" (styles.css `.competition-select`), so it can't widen
// the row. Add a line here when one shows up long on ?live=1.

const SHORT_NAMES: Record<string, string> = {
  // England
  "fa women's super league": "FAWSL",
  "fawsl (fa women's super league)": "FAWSL", // the database's own name (seen on ?live=1, 2026-10-09)
  "women's super league": "FAWSL",
  "fa women's championship": "WSL 2",
  "women's super league 2": "WSL 2",
  "fa women's cup": "FA Cup",
  "women's fa cup": "FA Cup",
  "fa women's league cup": "League Cup",
  "fa women's continental tyres league cup": "League Cup",
  "women's league cup": "League Cup",
  // Europe
  "uefa women's champions league": "UWCL",
  "women's champions league": "UWCL",
  "uefa women's europa cup": "UWEC",
  "liga f": "Liga F",
  "primera división femenina": "Liga F",
  "copa de la reina": "Copa Reina",
  "frauen bundesliga": "Frauen BL",
  "frauen-bundesliga": "Frauen BL",
  "dfb-pokal frauen": "DFB-Pokal",
  "première ligue": "Première Ligue",
  "division 1 féminine": "D1 Féminine",
  "coupe de france féminine": "Coupe de France",
  "serie a femminile": "Serie A",
  "coppa italia femminile": "Coppa Italia",
  "scottish women's premier league": "SWPL",
  // North America
  "nwsl": "NWSL",
  "national women's soccer league": "NWSL",
  "nwsl challenge cup": "Challenge Cup",
  "nwsl x liga mx femenil summer cup": "Summer Cup",
  "liga mx femenil": "Liga MX",
  // International
  "fifa women's world cup": "World Cup",
  "women's world cup": "World Cup",
  "uefa women's euro": "Euro",
  "uefa women's championship": "Euro",
  "women's euro": "Euro",
  "uefa women's nations league": "Nations League",
  "olympic games": "Olympics",
  "olympics": "Olympics",
  "shebelieves cup": "SheBelieves",
  "international friendlies": "Friendlies",
  "international friendly": "Friendlies",
};

/** The short name for the dropdown's closed button — the full name when none is listed. */
export function shortCompetitionName(fullName: string): string {
  return SHORT_NAMES[fullName.trim().toLowerCase()] ?? fullName;
}
